import { createApiRef } from '@backstage/core-plugin-api';

export type Aggregate = 'namespace' | 'controller';
export type Window = '24h' | '7d' | '30d';

export interface CostRow {
  name: string;
  cpuCost: number;
  ramCost: number;
  pvCost: number;
  networkCost: number;
  totalCost: number;
}

export interface AllocationPayload {
  window: string;
  aggregate: Aggregate;
  computedAt: number;
  total: number;
  rows: CostRow[];
}

export interface CostApi {
  getAllocation(window: Window, aggregate: Aggregate): Promise<AllocationPayload>;
}

export const costApiRef = createApiRef<CostApi>({
  id: 'plugin.cost.service',
});
